var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 26,
    viewBox: "0 0 50 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "switch_full"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "switch_bg",
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 25,
    rx: 12.5,
    fill: "#FAFAFA",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "switch",
    x: 24.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#06D6A0",
    stroke: "#05B384"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchFull);
export default __webpack_public_path__ + "static/media/switch_full.5114e696.svg";
export { ForwardRef as ReactComponent };